import React from 'react';

type TimeRemaining = {
	days: number;
	hours: number;
	minutes: number;
	isFinished: boolean;
};

export const useTimeRemaining = (endDate: string): TimeRemaining => {
	const [timeLeft, setTimeLeft] = React.useState<TimeRemaining>({
		days: 0,
		hours: 0,
		minutes: 0,
		isFinished: false
	});

	React.useEffect(() => {
		const calculateTimeLeft = () => {
			const end = new Date(endDate).getTime();
			const now = new Date().getTime();
			const diff = end - now;

			if (diff <= 0) {
				setTimeLeft({ days: 0, hours: 0, minutes: 0, isFinished: true });
				return;
			}

			const days = Math.floor(diff / (1000 * 60 * 60 * 24));
			const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

			setTimeLeft({ days, hours, minutes, isFinished: false });
		};

		calculateTimeLeft();
		const interval = setInterval(calculateTimeLeft, 1000);

		return () => clearInterval(interval);
	}, [endDate]);

	return timeLeft;
};
